/**
 * Common component to render a system note, icon and user information.
 *
 * This component need not be used with any store neither has any vuex dependency
 *
 * @example
 * <system-note
 *   :note="{
 *     id: String,
 *     author: Object,
 *     createdAt: String,
 *     bodyHtml: String,
 *     systemNoteIconName: String
 *    }"
 *   />
 */ import { GlButton, GlSkeletonLoader, GlTooltipDirective, GlIcon } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import $ from 'jquery';
import { renderGFM } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/behaviors/markdown/render_gfm.js?vue3';
import SafeHtml from '~/vue_shared/directives/safe_html';
import descriptionVersionHistoryMixin from '/builds/gitlab/gitlab-ee/ee/app/assets/javascripts/work_items/mixins/description_version_history.js?vue3';
import { getLocationHash } from '~/lib/utils/url_utility';
import { getIdFromGraphQLId } from '~/graphql_shared/utils';
import { __ } from '~/locale';
import NoteHeader from '/builds/gitlab/gitlab-ee/app/assets/javascripts/notes/components/note_header.vue?vue3';
import TimelineEntryItem from '~/vue_shared/components/notes/timeline_entry_item.vue';
const ICON_COLORS = {
    'issue-close': 'system-note-icon-info',
    issues: 'system-note-icon-success'
};
export default {
    i18n: {
        deleteButtonLabel: __('Remove description history')
    },
    name: 'SystemNote',
    components: {
        GlIcon,
        NoteHeader,
        TimelineEntryItem,
        GlButton,
        GlSkeletonLoader
    },
    directives: {
        GlTooltip: GlTooltipDirective,
        SafeHtml
    },
    mixins: [
        descriptionVersionHistoryMixin
    ],
    props: {
        note: {
            type: Object,
            required: true
        }
    },
    data () {
        return {
            isLoadingDescriptionVersion: false,
            descriptionVersions: {}
        };
    },
    computed: {
        targetNoteHash () {
            return getLocationHash();
        },
        noteAnchorId () {
            return `note_${this.noteId}`;
        },
        getIconColor () {
            return ICON_COLORS[this.note.systemNoteIconName] || '';
        },
        isAllowedIcon () {
            return Object.keys(ICON_COLORS).includes(this.note.systemNoteIconName);
        },
        isTargetNote () {
            return this.targetNoteHash === this.noteAnchorId;
        },
        actionTextHtml () {
            return $(this.note.bodyHtml).unwrap().html();
        },
        descriptionVersionId () {
            return getIdFromGraphQLId(this.systemNoteDescriptionVersion?.id);
        },
        noteId () {
            return getIdFromGraphQLId(this.note.id);
        },
        descriptionVersion () {
            return this.descriptionVersions[this.descriptionVersionId];
        },
        singleLineDescription () {
            return !this.descriptionVersion?.match(/\n/g);
        },
        deleteButtonClasses () {
            return this.singleLineDescription ? 'gl-top-5 gl-right-2 gl-mt-2' : 'gl-top-6 gl-right-3';
        },
        systemNoteIconName () {
            let icon = this.note.systemNoteIconName;
            if (this.note.systemNoteIconName === 'issues') {
                icon = 'issue-open-m';
            }
            return icon;
        }
    },
    mounted () {
        renderGFM(this.$refs['gfm-content']);
    },
    safeHtmlConfig: {
        ADD_TAGS: [
            'use'
        ]
    }
};
